const VideoComponent = require('../../viscomjs/video/VideoComponent');
const AbstractCommand = require('../../viscomjs/base/commands/AbstractCommand');
const analyticsEvent = require('../../viscomjs/analytics/analyticsEvent');

import {TimelineMax} from 'gsap';
const Shortcuts = require('./utils/Shortcuts');
const SizesUtils = require('../../viscomjs/utils/SizesUtils');
const win = window;

class PlayingCMD extends AbstractCommand {
    constructor() {
        super();
    }

    execute() {
        analyticsEvent('Video', 'autoplay', 'Start');
        super.execute(this);
    }
}

class ProgressCMD extends AbstractCommand {
    constructor(video) {
        super();
        this.video = video;
    }

    execute(p) {
        analyticsEvent('Video', 'progress', `Percentage ${p}%`);
        super.execute(this);
    }
}


const _addView = (instance, YTID) => {
    instance.video = new VideoComponent('video', {
        name: YTID,
        selector: instance.root,
        container: instance.root + '__container',
        src: [
            {src: './video/Vereshagin_no_title_no_music_1.mp4', type: 'video/mp4'},
            {src: './video/Vereshagin_no_title_no_music.webm', type: 'video/webm'}
        ],
        defaultMuted: true,
        loop: true
    });
    instance.videoRoot = document.querySelector(instance.root);
    instance.video.setPlayInformCommand(new PlayingCMD());
    instance.video.setProgressInformCommand(new ProgressCMD(instance.video));
}

const _constructTimeline = (instance, refDuration) => {

    const obj = {progress: 0, on: false, section: document.querySelector(instance.root)};
    const body = document.body;
    const tl = new TimelineMax({
        paused: true,
        onUpdate: () => {
            if (obj.progress < 0.999)
                obj.section.classList.remove('step2');
            else
                obj.section.classList.add('step2');

            const deactivate = () => {
                if (!obj.on) return;
                obj.on = false;
                obj.section.classList.remove('active');
                obj.section.classList.add('deactivate');
                body.dataset.video = 'false';
                if (obj.to) clearTimeout(obj.to);
                obj.to = setTimeout(() => {
                    obj.section.classList.remove('deactivate');
                    instance.video.stop();
                    analyticsEvent('Video', 'autoplay', 'Stop');
                }, 700);
            }

            if (obj.progress < 0.01) {
                deactivate();

                return;
            }
            if (obj.progress > 0.999) {
                deactivate();

                return;
            }
            if (obj.on) return;
            if (obj.to) clearTimeout(obj.to);
            obj.section.classList.remove('deactivate');
            obj.section.classList.add('active');
            body.dataset.video = 'true';
            instance.video.start();

            obj.on = true;
        }
    });

    tl.set(obj, {progress: 0}, 'st');
    tl.to(obj, refDuration * 0.3, {progress: 0.5}, 'st');
    tl.to(obj, refDuration * 0.3, {progress: 1}, 'st+=' + refDuration * 0.55);

    instance.timeline = tl;
    return tl;
}


function VideoTimelineConstructor(root, YTID, refDuration) {

    const constructor = {
        root: root
    };
    let _created = false;
    _addView(constructor, YTID);

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;

        const _onResize = function () {
            const instance = this;
            instance.video.updateOnResize(SizesUtils.winOffsetWidth(), SizesUtils.winOffsetHeight());
        };

        const _onClick = function () {
            const instance = this;
            if (instance.video.playing)
                instance.video.pause();
            else
                instance.video.play();
        };

        constructor.instance = {
            root: root,
            video: constructor.video,
            videoRoot: constructor.videoRoot
        };
        constructor.instance.onResize = _onResize.bind(constructor.instance);
        constructor.instance.onClick = _onClick.bind(constructor.instance);
        win.addEventListener('resize', constructor.instance.onResize);
        constructor.instance.videoRoot.addEventListener('click', constructor.instance.onClick);
        constructor.instance.onResize();
        _created = true;
        return _constructTimeline(constructor['instance'], refDuration);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        win.removeEventListener('resize', constructor.instance.onResize);
        constructor.instance.videoRoot.removeEventListener('click', constructor.instance.onClick);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = refDuration * 0.01;
    constructor.totalDuration = refDuration;

    return constructor;
}


module.exports = VideoTimelineConstructor;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/VideoTimeline.js